import styled, { useTheme } from "styled-components";

import {
  Button,
  Dialog,
  DialogActions,
  DialogSurface,
  DialogTrigger,
} from "@fluentui/react-components";
import parse from "html-react-parser";
import { devices } from "library/constants";
import { useCallback, useState } from "react";

import {
  ArrowRightRegular,
  Dismiss24Regular,
  EyeRegular,
} from "@fluentui/react-icons";

type Props = {
  html: string;
  imageSrc;
};

export function ClientLandingPagePreview({ html, imageSrc }: Props) {
  const theme = useTheme();
  const [previewLandingPage, setPreviewLandingPage] = useState(false);

  const handleOpenDialog = useCallback(() => {
    setPreviewLandingPage(true);
  }, []);

  const options = {
    replace({ attribs, children }) {
      if (!attribs) {
        return;
      }

      if (attribs.src) {
        return (
          <img
            src={attribs.src}
            style={{
              maxWidth: "100%",
            }}
            alt="some-text"
          />
        );
      }
    },
  } as any;

  return (
    <Dialog
      modalType="alert"
      open={previewLandingPage}
      onOpenChange={(event, data) => setPreviewLandingPage(data.open)}
    >
      <DialogTrigger>
        <Button
          icon={<EyeRegular />}
          appearance="transparent"
          onClick={handleOpenDialog}
        >
          Preview
        </Button>
      </DialogTrigger>

      <StyledDialogSurface
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <Container>
          <Content className="ql-editor">
            {parse(html, options)}
            <Button
              iconPosition="after"
              style={{
                marginTop: "20px",

                background: theme.palette.purpleDark,
                color: theme.palette.white,
                maxWidth: "fit-content",
              }}
              icon={<ArrowRightRegular />}
            >
              Get Started
            </Button>
          </Content>
          <LandingImg>
            <img src={imageSrc} alt="homepage" width={"100%"} />
          </LandingImg>
        </Container>
        <DialogActions>
          <DialogTrigger>
            <Button icon={<Dismiss24Regular />} appearance="secondary">
              Close
            </Button>
          </DialogTrigger>
        </DialogActions>
      </StyledDialogSurface>
    </Dialog>
  );
}

const StyledDialogSurface = styled(DialogSurface)`
  margin-left: 10px;
  margin-right: 10px;
  width: 95%;
  min-width: 95%;
  max-height: 98vh;
  padding: 15px;
  overflow-y: auto;
  @media only screen and ${devices.md} {
    width: 1200px;
    min-width: 1200px;
    padding: 24px;
    margin-left: auto;
    margin-right: auto;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  background: ${(props) => props.theme.palette.white};
  width: 100%;
  box-sizing: border-box;
  @media only screen and ${devices.md} {
    display: grid;

    grid-template-columns: 1fr 1fr;
  }
`;
const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: 20px;
`;

const LandingImg = styled.div`
  display: flex;
  width: 100%;
  img {
    object-fit: scale-down;
  }
`;
